import styled from 'styled-components';

import {colors, font} from 'theme';

export const Root = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    height: auto;
`;

export const Wrapper = styled.div`
    display: flex;
    gap: 10px;
    width: 100%;
    height: auto;
`;

export const HeadlineH2 = styled.h2`
    font-family: ${font.family.primary};
    font-weight: 500;
    font-size: 16px;
    line-height: 25px;
    letter-spacing: 0px;
    color: ${colors.darkGrey};
`;

export const WrapperItem = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    max-width: calc(50% - 5px);
    height: auto;
`;

export const CustomTitle = styled.h1`
    display: flex;
    font-size: 24px;
    font-weight: 600;
    color: #000;
    margin: 0;
    padding: 0 0 20px 0;
    gap: 10px;
    border-bottom: 1px solid ${colors.border};
`;

export const CustomTitleIcon = styled.div`
    display: flex;
    width: 36px;
    height: 36px;
    justify-content: center;
    align-items: center;
    background-color: ${colors.dangerSecondary};
    border-radius: 50%;
`;

export const CustomTitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 2px;
`;

export const CustomTitleText = styled.span<{size: 'sm' | 'md'}>`
    display: inline-flex;
    width: 100%;
    justify-content: flex-start;
    align-items: center;

    font-family: ${font.family.primary};
    font-size: ${({size}) => (size === 'sm' ? '14px' : '20px')};
    font-weight: ${({size}) => (size === 'sm' ? '400' : '600')};
    line-height: ${({size}) => (size === 'sm' ? '20px' : '19px')};
    color: ${({size}) => (size === 'sm' ? colors.textPrimary : colors.darkGrey)};
    margin: 0;
    padding: 0;
`;

export const CustomList = styled.ul<{action: 'add' | 'remove'}>`
    padding: 12px;
    margin: 0;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    list-style: none;
    background-color: ${({action}) => (action === 'add' ? '#FBFFFB' : '#FFF4F4')};
    border-color: ${({action}) => (action === 'add' ? colors.success : colors.danger)};

    > li {
        font-family: ${font.family.primary};
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0px;
    }
`;

export const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    width: 100%;
    height: auto;
    padding-top: 20px;
    border-top: 1px solid ${colors.border};
`;
